<template>
  <div>
    <el-card>
      <template #header>报告查询</template>
      <el-form :inline="true" @submit.prevent>
        <el-form-item label="用户ID">
          <el-input v-model.trim="reportQuery.user_id" placeholder="例如 1001" style="width: 140px" />
        </el-form-item>
        <el-form-item label="流派">
          <el-select v-model="reportQuery.method" clearable style="width: 140px">
            <el-option label="八字" value="bazi" />
            <el-option label="塔罗" value="tarot" />
            <el-option label="星盘" value="astrology" />
            <el-option label="紫微" value="ziwei" />
            <el-option label="数字命理" value="numerology" />
            <el-option label="六爻" value="liuyao" />
            <el-option label="姓名学" value="name" />
            <el-option label="综合" value="composite" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="reportLoading" @click="loadReports">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="reportList" stripe border v-loading="reportLoading" size="small">
        <el-table-column prop="report_id" label="报告ID" min-width="220" show-overflow-tooltip />
        <el-table-column prop="user_id" label="用户ID" width="90" />
        <el-table-column prop="method" label="流派" width="110" />
        <el-table-column prop="algorithm_version" label="算法版本" width="120" />
        <el-table-column prop="created_at" label="时间" min-width="160" />
        <el-table-column prop="summary" label="摘要" min-width="220" show-overflow-tooltip />
        <el-table-column label="操作" width="250" fixed="right">
          <template #default="{ row }">
            <el-space>
              <el-button link type="primary" @click="openReportDetail(row.report_id)">详情</el-button>
              <el-button link @click="openTicketCreate(row)">建工单</el-button>
            </el-space>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card style="margin-top: 12px;">
      <template #header>巡检配置</template>
      <el-form :inline="true" @submit.prevent>
        <el-form-item label="启用巡检"><el-switch v-model="opsConfig.enable" /></el-form-item>
        <el-form-item label="扫描间隔(分)">
          <el-input-number v-model="opsConfig.scan_interval_minutes" :min="1" :max="1440" />
        </el-form-item>
        <el-form-item label="告警窗口(天)">
          <el-input-number v-model="opsConfig.alerts_days" :min="1" :max="60" />
        </el-form-item>
        <el-form-item label="保存告警快照"><el-switch v-model="opsConfig.save_alert_snapshots" /></el-form-item>
        <el-form-item label="自动升级"><el-switch v-model="opsConfig.run_auto_escalate" /></el-form-item>
        <el-form-item label="升级超时(h)">
          <el-input-number v-model="opsConfig.escalate_overdue_hours" :min="1" :max="720" />
        </el-form-item>
        <el-form-item label="升级目标">
          <el-select v-model="opsConfig.escalate_to_priority" style="width: 120px">
            <el-option label="high" value="high" />
            <el-option label="urgent" value="urgent" />
          </el-select>
        </el-form-item>
        <el-form-item label="仅未指派"><el-switch v-model="opsConfig.only_unassigned" /></el-form-item>
        <el-form-item label="仅催办"><el-switch v-model="opsConfig.only_urged" /></el-form-item>
        <el-form-item label="最小催办次数">
          <el-input-number v-model="opsConfig.min_urge_count" :min="0" :max="99" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="opsConfigSaving" @click="saveOpsConfig">保存配置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button :loading="opsReloading" @click="reloadOpsCron">重载定时任务</el-button>
        </el-form-item>
        <el-form-item>
          <el-button :loading="opsRunsLoading" @click="loadOpsRuns">刷新执行日志</el-button>
        </el-form-item>
        <el-form-item label="触发方式">
          <el-select v-model="opsRunsQuery.trigger_type" clearable style="width: 120px">
            <el-option label="manual" value="manual" />
            <el-option label="cron" value="cron" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="opsRunsQuery.status" clearable style="width: 120px">
            <el-option label="success" value="success" />
            <el-option label="failed" value="failed" />
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="opsRunsQuery.date_range"
            type="daterange"
            value-format="YYYY-MM-DD"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 280px"
          />
        </el-form-item>
        <el-form-item>
          <el-button @click="searchOpsRuns">筛选日志</el-button>
        </el-form-item>
        <el-form-item>
          <el-badge :value="failedOpsCount" :hidden="failedOpsCount <= 0" type="danger">
            <el-button type="danger" plain @click="filterFailedOpsRuns">仅看失败</el-button>
          </el-badge>
        </el-form-item>
        <el-form-item label="每页条数">
          <el-select v-model="opsRunsQuery.page_size" style="width: 100px" @change="onOpsRunsPageSizeChange">
            <el-option label="10" :value="10" />
            <el-option label="20" :value="20" />
            <el-option label="50" :value="50" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetOpsRunsFilters">清空筛选</el-button>
        </el-form-item>
        <el-form-item>
          <el-button :disabled="opsRuns.length === 0" @click="exportOpsRunsCsv">导出CSV</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="opsRuns" :row-class-name="opsRunRowClassName" size="small" border style="margin-top: 8px;">
        <el-table-column label="时间" min-width="150">
          <template #default="{ row }">{{ formatTime(row.created_at) }}</template>
        </el-table-column>
        <el-table-column prop="trigger_type" label="触发" width="90" />
        <el-table-column label="状态" width="90">
          <template #default="{ row }">
            <el-tag size="small" :type="opsStatusTagType(row.status)">{{ row.status || '-' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="alerts_count" label="告警数" width="90" />
        <el-table-column label="升级数" width="90">
          <template #default="{ row }">
            <span class="escalated-count" :class="{ hot: Number(row.escalated_count || 0) > 0 }">{{ row.escalated_count || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="error_message" label="错误信息" min-width="180" show-overflow-tooltip />
        <el-table-column label="操作" width="90">
          <template #default="{ row }">
            <el-button link type="primary" @click="openOpsRunDetail(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="opsRunsTotal"
          :page-size="opsRunsQuery.page_size"
          :current-page="opsRunsQuery.page"
          @current-change="onOpsRunsPageChange"
        />
      </div>
    </el-card>

    <el-card style="margin-top: 12px;">
      <template #header>工单中心</template>
      <div style="margin-bottom: 10px;">
        <el-alert
          v-for="(item, idx) in ticketAlerts"
          :key="`${item.type}-${idx}`"
          :title="item.title"
          :description="item.message"
          :type="item.severity === 'high' ? 'error' : 'warning'"
          show-icon
          :closable="false"
          style="margin-bottom: 8px;"
        />
        <el-empty v-if="ticketAlerts.length === 0" description="暂无告警" :image-size="40" />
      </div>
      <el-row :gutter="10" style="margin-bottom: 10px;">
        <el-col :span="12">
          <el-card shadow="never">
            <template #header>近7天告警趋势</template>
            <el-table :data="alertTrend" size="small" border>
              <el-table-column prop="date" label="日期" width="110" />
              <el-table-column prop="scan_count" label="扫描次数" width="90" />
              <el-table-column prop="alert_total" label="告警总数" width="90" />
              <el-table-column prop="pending_max" label="待处理峰值" width="100" />
              <el-table-column label="催办率峰值">
                <template #default="{ row }">{{ formatPercentNum(row.urge_rate_max) }}</template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card shadow="never">
            <template #header>最近扫描记录</template>
            <el-table :data="alertHistory" size="small" border>
              <el-table-column label="扫描时间" min-width="150">
                <template #default="{ row }">{{ formatTime(row.scan_at) }}</template>
              </el-table-column>
              <el-table-column prop="alert_count" label="告警数" width="80" />
              <el-table-column prop="pending_count" label="待处理" width="80" />
              <el-table-column label="催办率" width="90">
                <template #default="{ row }">{{ formatPercentNum(row.urge_rate) }}</template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin-bottom: 10px;">
        <el-col :span="4"><el-statistic title="窗口新增" :value="Number(ticketKpi.created_count || 0)" /></el-col>
        <el-col :span="4"><el-statistic title="窗口已解决" :value="Number(ticketKpi.resolved_count || 0)" /></el-col>
        <el-col :span="4"><el-statistic title="当前待处理" :value="Number(ticketKpi.pending_count || 0)" /></el-col>
        <el-col :span="4"><el-statistic title="催办次数" :value="Number(ticketKpi.urge_count || 0)" /></el-col>
        <el-col :span="4"><el-statistic title="催办率" :value="ticketKpi.urge_rate || '0.00%'" /></el-col>
        <el-col :span="4"><el-statistic title="平均处理时长(h)" :value="ticketKpi.avg_resolve_hours || '0.00'" /></el-col>
        <el-col :span="4"><el-statistic title="首响达标率" :value="ticketKpi.first_response_sla_rate || '0.00%'" /></el-col>
        <el-col :span="4"><el-statistic title="解决达标率" :value="ticketKpi.resolve_sla_rate || '0.00%'" /></el-col>
      </el-row>
      <el-form :inline="true" @submit.prevent>
        <el-form-item label="统计窗口">
          <el-select v-model="ticketQuery.kpi_days" style="width: 120px" @change="loadTicketKpi">
            <el-option label="24小时" :value="1" />
            <el-option label="7天" :value="7" />
            <el-option label="30天" :value="30" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="ticketQuery.status" clearable style="width: 130px">
            <el-option label="待处理" value="open" />
            <el-option label="处理中" value="processing" />
            <el-option label="已解决" value="resolved" />
          </el-select>
        </el-form-item>
        <el-form-item label="分类">
          <el-select v-model="ticketQuery.category" clearable style="width: 160px">
            <el-option label="结果争议" value="result_dispute" />
            <el-option label="支付问题" value="payment_issue" />
            <el-option label="功能异常" value="bug_report" />
          </el-select>
        </el-form-item>
        <el-form-item label="SLA级别">
          <el-select v-model="ticketQuery.sla_level" clearable style="width: 130px">
            <el-option label="正常" value="normal" />
            <el-option label="预警" value="warning" />
            <el-option label="超时" value="danger" />
            <el-option label="已完成" value="resolved" />
          </el-select>
        </el-form-item>
        <el-form-item label="仅催办">
          <el-switch v-model="ticketQuery.only_urged" />
        </el-form-item>
        <el-form-item label="超时未处理">
          <el-switch v-model="ticketQuery.only_overdue" />
        </el-form-item>
        <el-form-item v-if="ticketQuery.only_overdue" label="超时阈值">
          <el-input-number v-model="ticketQuery.overdue_hours" :min="1" :max="720" :step="1" />
        </el-form-item>
        <el-form-item label="仅未指派升级">
          <el-switch v-model="ticketQuery.auto_only_unassigned" />
        </el-form-item>
        <el-form-item label="仅催办升级">
          <el-switch v-model="ticketQuery.auto_only_urged" />
        </el-form-item>
        <el-form-item label="最小催办次数">
          <el-input-number v-model="ticketQuery.auto_min_urge_count" :min="0" :max="99" :step="1" />
        </el-form-item>
        <el-form-item label="排序">
          <el-select v-model="ticketQuery.sort" style="width: 160px">
            <el-option label="最新优先" value="latest" />
            <el-option label="催办优先" value="urge_desc" />
          </el-select>
        </el-form-item>
        <el-form-item label="首响阈值">
          <el-input-number v-model="ticketQuery.sla_first_warn_hours" :min="1" :max="720" :step="1" />
        </el-form-item>
        <el-form-item label="首响超时阈值">
          <el-input-number v-model="ticketQuery.sla_first_danger_hours" :min="1" :max="720" :step="1" />
        </el-form-item>
        <el-form-item label="解决阈值">
          <el-input-number v-model="ticketQuery.sla_resolve_warn_hours" :min="1" :max="720" :step="1" />
        </el-form-item>
        <el-form-item label="解决超时阈值">
          <el-input-number v-model="ticketQuery.sla_resolve_danger_hours" :min="1" :max="720" :step="1" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="ticketLoading" @click="loadTickets">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="loadTicketKpi">刷新KPI</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" :loading="autoEscalateLoading" @click="runAutoEscalate">执行超时升级</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="opsRunLoading" @click="runOpsNow">一键巡检</el-button>
        </el-form-item>
        <el-form-item>
          <el-button :loading="alertsLoading" @click="loadTicketAlerts(true)">风险扫描</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="ticketList" stripe border v-loading="ticketLoading" size="small">
        <el-table-column prop="id" label="工单ID" width="90" />
        <el-table-column prop="user_id" label="用户ID" width="90" />
        <el-table-column prop="report_id" label="报告ID" min-width="170" show-overflow-tooltip />
        <el-table-column label="分类" width="130">
          <template #default="{ row }">{{ categoryText(row.category) }}</template>
        </el-table-column>
        <el-table-column label="优先级" width="90">
          <template #default="{ row }">{{ priorityText(row.priority) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="110">
          <template #default="{ row }">{{ statusText(row.status) }}</template>
        </el-table-column>
        <el-table-column prop="assignee_id" label="指派给" width="90" />
        <el-table-column label="用户补充" width="90">
          <template #default="{ row }">{{ row.user_comment_count || 0 }}</template>
        </el-table-column>
        <el-table-column label="用户催办" width="90">
          <template #default="{ row }">
            <el-tag :type="(row.user_urge_count || 0) > 0 ? 'danger' : 'info'" size="small">
              {{ row.user_urge_count || 0 }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="首响时长(h)" width="110">
          <template #default="{ row }">{{ row.first_response_hours || '-' }}</template>
        </el-table-column>
        <el-table-column label="解决时长(h)" width="110">
          <template #default="{ row }">{{ row.resolve_hours || '-' }}</template>
        </el-table-column>
        <el-table-column label="SLA" width="96">
          <template #default="{ row }">
            <el-tag :type="slaTagType(row.sla_level)" size="small">{{ slaLabel(row.sla_level) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="最后用户留言" min-width="220" show-overflow-tooltip>
          <template #default="{ row }">
            {{ row.last_user_message || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="content" label="内容" min-width="220" show-overflow-tooltip />
        <el-table-column label="操作" width="420" fixed="right">
          <template #default="{ row }">
            <el-space>
              <el-button link @click="openTicketDetail(row)">详情</el-button>
              <el-button link type="warning" @click="setHighPriority(row)">升高优先级</el-button>
              <el-button link type="primary" @click="copyLastMessage(row)">复制留言</el-button>
              <el-button link @click="openAssign(row)">指派</el-button>
              <el-button link type="success" @click="openResolve(row)">处理</el-button>
            </el-space>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog v-model="ticketDialog.visible" title="创建工单" width="520px">
      <el-form label-width="100px">
        <el-form-item label="用户ID"><el-input v-model.number="ticketDialog.form.user_id" /></el-form-item>
        <el-form-item label="报告ID"><el-input v-model="ticketDialog.form.report_id" /></el-form-item>
        <el-form-item label="分类">
          <el-select v-model="ticketDialog.form.category" style="width: 100%">
            <el-option label="结果争议" value="result_dispute" />
            <el-option label="支付问题" value="payment_issue" />
            <el-option label="功能异常" value="bug_report" />
          </el-select>
        </el-form-item>
        <el-form-item label="优先级">
          <el-select v-model="ticketDialog.form.priority" style="width: 100%">
            <el-option label="low" value="low" />
            <el-option label="medium" value="medium" />
            <el-option label="high" value="high" />
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="ticketDialog.form.content" type="textarea" :rows="4" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="ticketDialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="ticketDialog.loading" @click="submitTicket">提交</el-button>
      </template>
    </el-dialog>

    <el-dialog v-model="reportDetailDialog.visible" title="报告详情" width="920px">
      <div v-loading="reportDetailDialog.loading">
        <template v-if="reportDetailDialog.data">
          <el-card shadow="never" class="report-detail-summary-card">
            <div class="report-detail-top">
              <div>
                <div class="report-main-id">{{ reportDetailDialog.report_id }}</div>
                <div class="report-sub-meta">
                  用户 {{ reportDetailDialog.data.user_id || '-' }} ·
                  生成时间 {{ formatTime(reportDetailDialog.data.created_at) }}
                </div>
              </div>
              <el-space>
                <el-tag type="info">{{ reportDetailMethodLabel(reportDetailDialog.data) }}</el-tag>
                <el-tag>{{ reportDetailVersion(reportDetailDialog.data) }}</el-tag>
              </el-space>
            </div>
            <div class="report-detail-actions">
              <el-space wrap>
                <el-button size="small" @click="copyReportDetailSummary">复制摘要</el-button>
                <el-button size="small" type="primary" @click="createTicketFromReportDetail">从该报告建工单</el-button>
                <el-button size="small" @click="refreshReportDetail">刷新</el-button>
              </el-space>
            </div>
          </el-card>

          <el-row :gutter="12">
            <el-col :span="12">
              <el-card shadow="never" class="report-detail-card">
                <template #header><div class="detail-card-header">用户问题</div></template>
                <div class="report-detail-content">{{ reportDetailQuestion(reportDetailDialog.data) }}</div>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card shadow="never" class="report-detail-card">
                <template #header><div class="detail-card-header">结论摘要</div></template>
                <div class="report-detail-content">{{ reportDetailSummary(reportDetailDialog.data) }}</div>
              </el-card>
            </el-col>
          </el-row>

          <el-card shadow="never" class="report-detail-card">
            <template #header><div class="detail-card-header">算法与输入快照</div></template>
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="算法版本">{{ reportDetailVersion(reportDetailDialog.data) }}</el-descriptions-item>
              <el-descriptions-item label="流派">{{ reportDetailMethodLabel(reportDetailDialog.data) }}</el-descriptions-item>
              <el-descriptions-item label="问题" :span="2">{{ reportDetailQuestion(reportDetailDialog.data) }}</el-descriptions-item>
            </el-descriptions>
            <div class="debug-tip-row">
              <span class="debug-tip-text">以下为技术调试信息，仅用于排查数据异常或核对算法输出。</span>
              <el-button text type="primary" @click="toggleReportDebug">
                {{ reportDetailDialog.show_debug ? '收起调试信息' : '展开调试信息' }}
              </el-button>
            </div>
            <el-collapse v-if="reportDetailDialog.show_debug" style="margin-top: 10px;">
              <el-collapse-item title="请求参数 JSON">
                <pre class="json-pre">{{ prettyJSON(reportDetailDialog.data.request) }}</pre>
              </el-collapse-item>
              <el-collapse-item title="算法结果 JSON">
                <pre class="json-pre">{{ prettyJSON(reportDetailDialog.data.engine) }}</pre>
              </el-collapse-item>
              <el-collapse-item title="解释结果 JSON">
                <pre class="json-pre">{{ prettyJSON(reportDetailDialog.data.interpret) }}</pre>
              </el-collapse-item>
            </el-collapse>
          </el-card>
        </template>
      </div>
      <template #footer>
        <el-button @click="reportDetailDialog.visible = false">关闭</el-button>
      </template>
    </el-dialog>

    <el-dialog v-model="detailDialog.visible" title="工单详情工作台" width="920px">
      <div v-loading="detailDialog.loading">
        <template v-if="detailDialog.ticket">
          <el-card shadow="never" class="detail-summary-card">
            <div class="detail-summary-top">
              <div class="detail-summary-left">
                <div class="ticket-main-id">#{{ detailDialog.ticket.id }}</div>
                <div class="ticket-sub-meta">
                  用户 {{ detailDialog.ticket.user_id || '-' }} ·
                  报告 {{ detailDialog.ticket.report_id || '-' }} ·
                  {{ formatTime(detailDialog.ticket.created_at) }}
                </div>
              </div>
              <el-space>
                <el-tag :type="statusTagType(detailDialog.ticket.status)">{{ statusText(detailDialog.ticket.status) }}</el-tag>
                <el-tag :type="priorityTagType(detailDialog.ticket.priority)">优先级 {{ priorityText(detailDialog.ticket.priority) }}</el-tag>
                <el-tag type="info">{{ categoryText(detailDialog.ticket.category) }}</el-tag>
                <el-tag :type="slaTagType(detailDialog.ticket.sla_level)">{{ slaLabel(detailDialog.ticket.sla_level) }}</el-tag>
              </el-space>
            </div>
            <div class="detail-summary-bottom">
              <el-space wrap>
                <el-button size="small" @click="copyDetailSummary">复制摘要</el-button>
                <el-button size="small" @click="detailAssign">指派</el-button>
                <el-button size="small" type="warning" @click="detailSetHighPriority">升优先级</el-button>
                <el-button size="small" type="success" @click="detailResolve">处理完成</el-button>
                <el-button size="small" @click="refreshDetailDialog">刷新</el-button>
              </el-space>
            </div>
          </el-card>

          <el-card shadow="never" class="detail-progress-card">
            <template #header>
              <div class="detail-card-header">处理进度</div>
            </template>
            <el-steps :active="ticketStepIndex(detailDialog.ticket.status)" finish-status="success" align-center>
              <el-step title="已提交" />
              <el-step title="处理中" />
              <el-step title="已解决" />
            </el-steps>
            <div class="detail-sla-row">
              <el-alert
                :type="slaAlertType(detailDialog.ticket.sla_level)"
                :closable="false"
                show-icon
                :title="`SLA状态：${slaLabel(detailDialog.ticket.sla_level)}，工单存续：${ticketLiveDuration(detailDialog.ticket)}`"
              />
            </div>
          </el-card>

          <el-row :gutter="12">
            <el-col :span="12">
              <el-card shadow="never" class="detail-info-card">
                <template #header>
                  <div class="detail-card-header">基础信息</div>
                </template>
                <el-descriptions :column="1" size="small" border>
                  <el-descriptions-item label="工单ID">#{{ detailDialog.ticket.id }}</el-descriptions-item>
                  <el-descriptions-item label="用户ID">{{ detailDialog.ticket.user_id || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="指派客服">{{ detailDialog.ticket.assignee_id || '-' }}</el-descriptions-item>
                  <el-descriptions-item label="创建时间">{{ formatTime(detailDialog.ticket.created_at) }}</el-descriptions-item>
                  <el-descriptions-item label="更新时间">{{ formatTime(detailDialog.ticket.updated_at) }}</el-descriptions-item>
                  <el-descriptions-item label="完成时间">{{ formatTime(detailDialog.ticket.resolved_at) }}</el-descriptions-item>
                </el-descriptions>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card shadow="never" class="detail-info-card">
                <template #header>
                  <div class="detail-card-header">用户诉求</div>
                </template>
                <div class="detail-block-content">{{ detailDialog.ticket.content || '-' }}</div>
              </el-card>
              <el-card shadow="never" class="detail-info-card">
                <template #header>
                  <div class="detail-card-header">处理结论</div>
                </template>
                <div class="detail-block-content" :class="{ muted: !detailDialog.ticket.resolution }">
                  {{ detailDialog.ticket.resolution || '尚未处理完成' }}
                </div>
              </el-card>
            </el-col>
          </el-row>
        </template>

        <el-card shadow="never" class="detail-timeline-card">
          <template #header>
            <div class="detail-card-header">处理时间线（{{ detailDialog.logs.length }}）</div>
          </template>
          <el-empty v-if="!detailDialog.logs.length" description="暂无处理记录" :image-size="50" />
          <el-timeline v-else>
            <el-timeline-item
              v-for="item in detailDialog.logs"
              :key="item.id"
              :type="ticketLogType(item.action)"
              :timestamp="formatTime(item.created_at)"
              placement="top"
            >
              <div class="timeline-title">{{ ticketActionText(item.action) }}</div>
              <div class="timeline-detail">{{ item.detail || '-' }}</div>
            </el-timeline-item>
          </el-timeline>
        </el-card>
      </div>
      <template #footer>
        <el-button @click="detailDialog.visible = false">关闭</el-button>
      </template>
    </el-dialog>

    <el-dialog v-model="opsRunDetail.visible" title="巡检执行详情" width="680px">
      <el-descriptions :column="2" border size="small" v-if="opsRunDetail.row">
        <el-descriptions-item label="执行时间">{{ formatTime(opsRunDetail.row.created_at) }}</el-descriptions-item>
        <el-descriptions-item label="触发方式">{{ opsRunDetail.row.trigger_type }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag size="small" :type="opsStatusTagType(opsRunDetail.row.status)">{{ opsRunDetail.row.status || '-' }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="告警数">{{ opsRunDetail.row.alerts_count }}</el-descriptions-item>
        <el-descriptions-item label="升级数">
          <span class="escalated-count" :class="{ hot: Number(opsRunDetail.row.escalated_count || 0) > 0 }">
            {{ opsRunDetail.row.escalated_count || 0 }}
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="错误信息" :span="2">{{ opsRunDetail.row.error_message || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div style="margin-top: 10px;">
        <el-collapse v-model="opsRunDetail.activePanels">
          <el-collapse-item name="summary" title="概要">
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="run_alerts">{{ formatAny(opsRunDetail.parsed?.run_alerts) }}</el-descriptions-item>
              <el-descriptions-item label="run_escalate">{{ formatAny(opsRunDetail.parsed?.run_escalate) }}</el-descriptions-item>
              <el-descriptions-item label="alerts_saved">{{ formatAny(opsRunDetail.parsed?.alerts_saved) }}</el-descriptions-item>
              <el-descriptions-item label="days">{{ formatAny(opsRunDetail.parsed?.days) }}</el-descriptions-item>
            </el-descriptions>
          </el-collapse-item>
          <el-collapse-item name="escalate" title="升级结果">
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="checked">{{ formatAny(opsRunDetail.parsed?.escalate?.checked) }}</el-descriptions-item>
              <el-descriptions-item label="updated">{{ formatAny(opsRunDetail.parsed?.escalate?.updated) }}</el-descriptions-item>
              <el-descriptions-item label="overdue_hours">{{ formatAny(opsRunDetail.parsed?.escalate?.overdue_hours) }}</el-descriptions-item>
              <el-descriptions-item label="to_priority">{{ formatAny(opsRunDetail.parsed?.escalate?.to_priority) }}</el-descriptions-item>
              <el-descriptions-item label="updated_ids" :span="2">{{ formatAny(opsRunDetail.parsed?.escalate?.updated_ids) }}</el-descriptions-item>
            </el-descriptions>
          </el-collapse-item>
          <el-collapse-item name="raw" title="原始 JSON">
            <pre class="json-pre">{{ opsRunDetail.pretty }}</pre>
          </el-collapse-item>
        </el-collapse>
      </div>
      <template #footer>
        <el-button type="primary" @click="copyOpsUpdatedIds">复制升级工单ID</el-button>
        <el-button @click="opsRunDetail.visible = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, reactive, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { adminApi } from '../api/admin'

const reportLoading = ref(false)
const reportList = ref([])
const reportQuery = reactive({ user_id: '', method: '' })
const reportDetailDialog = reactive({
  visible: false,
  loading: false,
  report_id: '',
  data: null,
  show_debug: false
})

const ticketLoading = ref(false)
const ticketList = ref([])
const alertsLoading = ref(false)
const autoEscalateLoading = ref(false)
const opsRunLoading = ref(false)
const opsConfigSaving = ref(false)
const opsReloading = ref(false)
const opsRunsLoading = ref(false)
const ticketAlerts = ref([])
const alertHistory = ref([])
const alertTrend = ref([])
const opsRuns = ref([])
const opsRunsTotal = ref(0)
const failedOpsCount = ref(0)
const latestFailedRunID = ref(0)
let failedCountTimer = null
const opsRunsQuery = reactive({
  page: 1,
  page_size: 10,
  trigger_type: '',
  status: '',
  date_range: []
})
const opsConfig = reactive({
  enable: true,
  scan_interval_minutes: 60,
  alerts_days: 1,
  save_alert_snapshots: true,
  run_auto_escalate: true,
  escalate_overdue_hours: 24,
  escalate_to_priority: 'high',
  only_unassigned: true,
  only_urged: false,
  min_urge_count: 0
})
const ticketKpi = reactive({
  created_count: 0,
  resolved_count: 0,
  pending_count: 0,
  urge_count: 0,
  urge_rate: '0.00%',
  avg_resolve_hours: '0.00',
  first_response_sla_rate: '0.00%',
  resolve_sla_rate: '0.00%'
})
const ticketQuery = reactive({
  kpi_days: 1,
  status: '',
  category: '',
  sla_level: '',
  only_urged: false,
  only_overdue: false,
  overdue_hours: 24,
  auto_only_unassigned: true,
  auto_only_urged: false,
  auto_min_urge_count: 0,
  sort: 'latest',
  sla_first_warn_hours: 8,
  sla_first_danger_hours: 24,
  sla_resolve_warn_hours: 24,
  sla_resolve_danger_hours: 72
})

const ticketDialog = reactive({
  visible: false,
  loading: false,
  form: { user_id: 0, report_id: '', category: 'result_dispute', priority: 'medium', content: '' }
})
const detailDialog = reactive({
  visible: false,
  loading: false,
  ticket: null,
  logs: []
})
const opsRunDetail = reactive({
  visible: false,
  row: null,
  parsed: null,
  pretty: '',
  activePanels: ['summary', 'escalate']
})

function statusText(value) {
  const map = {
    open: '待处理',
    processing: '处理中',
    resolved: '已解决'
  }
  return map[value] || value || '-'
}

function categoryText(value) {
  const map = {
    result_dispute: '结果争议',
    payment_issue: '支付问题',
    bug_report: '功能异常',
    subscription_issue: '会员问题'
  }
  return map[value] || value || '-'
}

function priorityText(value) {
  const map = {
    low: '低',
    medium: '中',
    high: '高',
    urgent: '紧急'
  }
  return map[value] || value || '-'
}

function ticketActionText(value) {
  const map = {
    create: '后台创建',
    create_by_user: '用户提交',
    user_comment: '用户补充',
    user_urge: '用户催办',
    set_priority: '调整优先级',
    assign: '客服指派',
    resolve: '客服处理'
  }
  return map[value] || value || '-'
}

function slaLabel(value) {
  const map = {
    normal: '正常',
    warning: '预警',
    danger: '超时',
    resolved: '已完成'
  }
  return map[value] || '正常'
}

function slaTagType(value) {
  const map = {
    normal: 'success',
    warning: 'warning',
    danger: 'danger',
    resolved: 'info'
  }
  return map[value] || 'success'
}

function statusTagType(value) {
  const map = {
    open: 'warning',
    processing: '',
    resolved: 'success'
  }
  return map[value] || 'info'
}

function priorityTagType(value) {
  const map = {
    low: 'info',
    medium: '',
    high: 'warning',
    urgent: 'danger'
  }
  return map[value] || 'info'
}

function ticketStepIndex(status) {
  if (status === 'resolved') return 2
  if (status === 'processing') return 1
  return 0
}

function slaAlertType(level) {
  const map = {
    normal: 'success',
    warning: 'warning',
    danger: 'error',
    resolved: 'info'
  }
  return map[level] || 'info'
}

function ticketLiveDuration(ticket) {
  if (!ticket?.created_at) return '-'
  const start = new Date(ticket.created_at).getTime()
  const end = ticket?.resolved_at ? new Date(ticket.resolved_at).getTime() : Date.now()
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return '-'
  const diffMinutes = Math.floor((end - start) / 60000)
  if (diffMinutes < 60) return `${Math.max(diffMinutes, 1)}分钟`
  const hours = Math.floor(diffMinutes / 60)
  if (hours < 24) return `${hours}小时`
  const days = Math.floor(hours / 24)
  const remainHours = hours % 24
  return `${days}天${remainHours}小时`
}

function ticketLogType(action) {
  if (action === 'resolve') return 'success'
  if (action === 'user_urge') return 'warning'
  if (action === 'set_priority' || action === 'assign') return 'primary'
  return 'info'
}

function formatTime(value) {
  if (!value) return '-'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return String(value)
  return d.toLocaleString()
}

function formatPercentNum(value) {
  const n = Number(value || 0)
  if (!Number.isFinite(n)) return '0.00%'
  return `${n.toFixed(2)}%`
}

function formatAny(value) {
  if (value === null || value === undefined || value === '') return '-'
  if (Array.isArray(value)) return value.join(', ')
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

function prettyJSON(value) {
  if (value === null || value === undefined) return '{}'
  if (typeof value === 'string') {
    try {
      return JSON.stringify(JSON.parse(value), null, 2)
    } catch (_) {
      return value
    }
  }
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value, null, 2)
    } catch (_) {
      return String(value)
    }
  }
  return String(value)
}

function reportDetailMethodLabel(data) {
  return data?.engine?.method || data?.method || '-'
}

function reportDetailVersion(data) {
  return data?.engine?.algorithm_version || data?.algorithm_version || '-'
}

function reportDetailQuestion(data) {
  return data?.request?.question || data?.request?.content || data?.question || '-'
}

function reportDetailSummary(data) {
  const candidates = [
    data?.interpret?.summary,
    data?.interpret?.emotional_support,
    data?.summary,
    data?.request?.question
  ]
  for (const item of candidates) {
    const text = String(item || '').trim()
    if (text) return text
  }
  return '暂无结论摘要（该报告可能尚未生成解读记录）'
}

function opsStatusTagType(status) {
  if (status === 'success') return 'success'
  if (status === 'failed') return 'danger'
  return 'info'
}

function opsRunRowClassName({ row }) {
  if (Number(row?.id || 0) > 0 && Number(row?.id || 0) === Number(latestFailedRunID.value || 0)) {
    return 'ops-run-highlight'
  }
  return ''
}

async function loadReports() {
  reportLoading.value = true
  try {
    const data = await adminApi.reports({
      page: 1,
      page_size: 20,
      user_id: reportQuery.user_id || undefined,
      method: reportQuery.method || undefined
    })
    reportList.value = data.list || []
  } catch (e) {
    ElMessage.error(e.message || '加载报告失败')
  } finally {
    reportLoading.value = false
  }
}

async function openReportDetail(reportId) {
  reportDetailDialog.visible = true
  reportDetailDialog.loading = true
  reportDetailDialog.report_id = reportId
  reportDetailDialog.data = null
  reportDetailDialog.show_debug = false
  try {
    const data = await adminApi.reportDetail(reportId)
    reportDetailDialog.data = data || null
  } catch (e) {
    ElMessage.error(e.message || '加载报告详情失败')
    reportDetailDialog.visible = false
  } finally {
    reportDetailDialog.loading = false
  }
}

async function refreshReportDetail() {
  const reportID = String(reportDetailDialog.report_id || '').trim()
  if (!reportID) return
  await openReportDetail(reportID)
}

async function copyReportDetailSummary() {
  const data = reportDetailDialog.data
  if (!data) return
  const text = [
    `报告ID：${reportDetailDialog.report_id || '-'}`,
    `用户ID：${data.user_id || '-'}`,
    `流派：${reportDetailMethodLabel(data)}`,
    `算法版本：${reportDetailVersion(data)}`,
    `问题：${reportDetailQuestion(data)}`,
    `结论：${reportDetailSummary(data)}`
  ].join('\n')
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      ElMessage.success('报告摘要已复制')
      return
    }
  } catch (_) {
  }
  try {
    const input = document.createElement('textarea')
    input.value = text
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
    ElMessage.success('报告摘要已复制')
  } catch (_) {
    ElMessage.error('复制失败，请手动复制')
  }
}

function openTicketCreate(report) {
  ticketDialog.form.user_id = Number(report.user_id || 0)
  ticketDialog.form.report_id = report.report_id || ''
  ticketDialog.form.category = 'result_dispute'
  ticketDialog.form.priority = 'medium'
  ticketDialog.form.content = report.summary || ''
  ticketDialog.visible = true
}

function createTicketFromReportDetail() {
  const data = reportDetailDialog.data
  if (!data) return
  openTicketCreate({
    user_id: data.user_id || 0,
    report_id: reportDetailDialog.report_id || data.report_id || '',
    summary: reportDetailSummary(data)
  })
  reportDetailDialog.visible = false
  ElMessage.success('已带入报告信息到建工单表单')
}

function toggleReportDebug() {
  reportDetailDialog.show_debug = !reportDetailDialog.show_debug
}

async function submitTicket() {
  if (!ticketDialog.form.user_id || !ticketDialog.form.content) {
    ElMessage.warning('用户ID和内容必填')
    return
  }
  ticketDialog.loading = true
  try {
    await adminApi.ticketCreate(ticketDialog.form)
    ElMessage.success('工单已创建')
    ticketDialog.visible = false
    await loadTickets()
  } catch (e) {
    ElMessage.error(e.message || '创建工单失败')
  } finally {
    ticketDialog.loading = false
  }
}

async function loadTickets() {
  ticketLoading.value = true
  try {
    const data = await adminApi.ticketList({
      page: 1,
      page_size: 30,
      status: ticketQuery.status || undefined,
      category: ticketQuery.category || undefined,
      sla_level: ticketQuery.sla_level || undefined,
      only_urged: ticketQuery.only_urged ? 1 : undefined,
      only_overdue: ticketQuery.only_overdue ? 1 : undefined,
      overdue_hours: ticketQuery.only_overdue ? ticketQuery.overdue_hours : undefined,
      sort: ticketQuery.sort === 'urge_desc' ? 'urge_desc' : undefined,
      sla_first_warn_hours: ticketQuery.sla_first_warn_hours,
      sla_first_danger_hours: ticketQuery.sla_first_danger_hours,
      sla_resolve_warn_hours: ticketQuery.sla_resolve_warn_hours,
      sla_resolve_danger_hours: ticketQuery.sla_resolve_danger_hours
    })
    ticketList.value = data.list || []
  } catch (e) {
    ElMessage.error(e.message || '加载工单失败')
  } finally {
    ticketLoading.value = false
  }
}

async function loadTicketKpi() {
  try {
    const data = await adminApi.ticketKpi({
      days: ticketQuery.kpi_days || 1,
      sla_first_target_hours: ticketQuery.sla_first_warn_hours,
      sla_resolve_target_hours: ticketQuery.sla_resolve_warn_hours
    })
    ticketKpi.created_count = Number(data.created_count || 0)
    ticketKpi.resolved_count = Number(data.resolved_count || 0)
    ticketKpi.pending_count = Number(data.pending_count || 0)
    ticketKpi.urge_count = Number(data.urge_count || 0)
    ticketKpi.urge_rate = data.urge_rate || '0.00%'
    ticketKpi.avg_resolve_hours = data.avg_resolve_hours || '0.00'
    ticketKpi.first_response_sla_rate = data.first_response_sla_rate || '0.00%'
    ticketKpi.resolve_sla_rate = data.resolve_sla_rate || '0.00%'
  } catch (e) {
    ElMessage.error(e.message || '加载工单KPI失败')
  }
}

async function loadTicketAlerts(save = false) {
  alertsLoading.value = true
  try {
    const data = await adminApi.ticketAlerts({
      days: ticketQuery.kpi_days || 1,
      save: save ? 1 : undefined
    })
    ticketAlerts.value = data.alerts || []
    if (save) {
      await loadAlertHistory()
    }
  } catch (e) {
    ElMessage.error(e.message || '加载告警失败')
  } finally {
    alertsLoading.value = false
  }
}

async function loadAlertHistory() {
  try {
    const data = await adminApi.ticketAlertHistory({
      days: 7,
      limit: 50
    })
    alertHistory.value = data.list || []
    alertTrend.value = data.trend || []
  } catch (e) {
    ElMessage.error(e.message || '加载告警历史失败')
  }
}

async function loadOpsConfig() {
  try {
    const data = await adminApi.ticketOpsConfig()
    opsConfig.enable = !!data.enable
    opsConfig.scan_interval_minutes = Number(data.scan_interval_minutes || 60)
    opsConfig.alerts_days = Number(data.alerts_days || 1)
    opsConfig.save_alert_snapshots = !!data.save_alert_snapshots
    opsConfig.run_auto_escalate = !!data.run_auto_escalate
    opsConfig.escalate_overdue_hours = Number(data.escalate_overdue_hours || 24)
    opsConfig.escalate_to_priority = data.escalate_to_priority || 'high'
    opsConfig.only_unassigned = !!data.only_unassigned
    opsConfig.only_urged = !!data.only_urged
    opsConfig.min_urge_count = Number(data.min_urge_count || 0)
  } catch (e) {
    ElMessage.error(e.message || '加载巡检配置失败')
  }
}

async function saveOpsConfig() {
  opsConfigSaving.value = true
  try {
    await adminApi.ticketOpsConfigUpdate({
      ...opsConfig
    })
    ElMessage.success('巡检配置已保存并自动重载')
    await loadOpsRuns()
  } catch (e) {
    ElMessage.error(e.message || '保存巡检配置失败')
  } finally {
    opsConfigSaving.value = false
  }
}

async function reloadOpsCron() {
  opsReloading.value = true
  try {
    await adminApi.ticketOpsReload()
    ElMessage.success('定时任务已重载')
    await loadOpsRuns()
  } catch (e) {
    ElMessage.error(e.message || '重载定时任务失败')
  } finally {
    opsReloading.value = false
  }
}

async function loadOpsRuns() {
  opsRunsLoading.value = true
  try {
    const dateFrom = Array.isArray(opsRunsQuery.date_range) ? opsRunsQuery.date_range[0] : undefined
    const dateTo = Array.isArray(opsRunsQuery.date_range) ? opsRunsQuery.date_range[1] : undefined
    const data = await adminApi.ticketOpsRuns({
      page: opsRunsQuery.page,
      page_size: opsRunsQuery.page_size,
      trigger_type: opsRunsQuery.trigger_type || undefined,
      status: opsRunsQuery.status || undefined,
      date_from: dateFrom || undefined,
      date_to: dateTo || undefined
    })
    const list = Array.isArray(data.list) ? data.list : []
    list.sort((a, b) => {
      const aFailed = a?.status === 'failed' ? 1 : 0
      const bFailed = b?.status === 'failed' ? 1 : 0
      if (aFailed !== bFailed) return bFailed - aFailed
      return Number(b?.id || 0) - Number(a?.id || 0)
    })
    opsRuns.value = list
    opsRunsTotal.value = Number(data.total || 0)
    if (opsRunsQuery.status === 'failed' && opsRunsQuery.page === 1) {
      latestFailedRunID.value = Number((list[0] && list[0].id) || 0)
    } else if (opsRunsQuery.status !== 'failed') {
      latestFailedRunID.value = 0
    }
  } catch (e) {
    ElMessage.error(e.message || '加载执行日志失败')
  } finally {
    opsRunsLoading.value = false
  }
  await loadFailedOpsCount()
}

async function loadFailedOpsCount() {
  try {
    const data = await adminApi.ticketOpsRuns({
      page: 1,
      page_size: 1,
      status: 'failed'
    })
    failedOpsCount.value = Number(data.total || 0)
  } catch (_) {
    failedOpsCount.value = 0
  }
}

function searchOpsRuns() {
  opsRunsQuery.page = 1
  loadOpsRuns()
}

function filterFailedOpsRuns() {
  opsRunsQuery.page = 1
  opsRunsQuery.status = 'failed'
  latestFailedRunID.value = 0
  loadOpsRuns()
}

function onOpsRunsPageChange(page) {
  opsRunsQuery.page = Number(page || 1)
  loadOpsRuns()
}

function onOpsRunsPageSizeChange() {
  opsRunsQuery.page = 1
  loadOpsRuns()
}

function resetOpsRunsFilters() {
  opsRunsQuery.page = 1
  opsRunsQuery.page_size = 10
  opsRunsQuery.trigger_type = ''
  opsRunsQuery.status = ''
  opsRunsQuery.date_range = []
  loadOpsRuns()
}

function exportOpsRunsCsv() {
  if (!opsRuns.value.length) {
    ElMessage.warning('暂无可导出日志')
    return
  }
  const escapeCsv = (value) => {
    const text = value === null || value === undefined ? '' : String(value)
    if (text.includes(',') || text.includes('"') || text.includes('\n')) {
      return `"${text.replace(/"/g, '""')}"`
    }
    return text
  }
  const header = ['id', 'created_at', 'trigger_type', 'status', 'alerts_count', 'escalated_count', 'error_message']
  const lines = [header.join(',')]
  for (const row of opsRuns.value) {
    lines.push(
      [
        escapeCsv(row.id),
        escapeCsv(row.created_at),
        escapeCsv(row.trigger_type),
        escapeCsv(row.status),
        escapeCsv(row.alerts_count),
        escapeCsv(row.escalated_count),
        escapeCsv(row.error_message)
      ].join(',')
    )
  }
  const csv = '\uFEFF' + lines.join('\n')
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `ticket_ops_runs_${Date.now()}.csv`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
  ElMessage.success('巡检日志CSV已导出')
}

function openOpsRunDetail(row) {
  opsRunDetail.row = row
  try {
    const parsed = row?.detail_json ? JSON.parse(row.detail_json) : {}
    opsRunDetail.parsed = parsed
    opsRunDetail.pretty = JSON.stringify(parsed, null, 2)
  } catch (_) {
    opsRunDetail.parsed = null
    opsRunDetail.pretty = row?.detail_json || '{}'
  }
  opsRunDetail.activePanels = ['summary', 'escalate']
  opsRunDetail.visible = true
}

async function copyOpsUpdatedIds() {
  const text = opsRunDetail.pretty || ''
  let ids = []
  try {
    const parsed = text ? JSON.parse(text) : {}
    ids = parsed?.escalate?.updated_ids || []
  } catch (_) {
    ids = []
  }
  if (!Array.isArray(ids) || ids.length === 0) {
    ElMessage.warning('当前记录没有可复制的升级工单ID')
    return
  }
  const payload = ids.join(',')
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(payload)
      ElMessage.success(`已复制 ${ids.length} 个工单ID`)
      return
    }
  } catch (_) {
  }
  try {
    const input = document.createElement('textarea')
    input.value = payload
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
    ElMessage.success(`已复制 ${ids.length} 个工单ID`)
  } catch (_) {
    ElMessage.error('复制失败，请手动复制')
  }
}

async function loadTicketDetailByID(ticketID) {
  detailDialog.loading = true
  try {
    const data = await adminApi.ticketDetail(ticketID)
    detailDialog.ticket = data.ticket || null
    detailDialog.logs = data.logs || []
  } catch (e) {
    ElMessage.error(e.message || '加载工单详情失败')
    throw e
  } finally {
    detailDialog.loading = false
  }
}

async function refreshDetailDialog() {
  const id = Number(detailDialog.ticket?.id || 0)
  if (!id) return
  try {
    await loadTicketDetailByID(id)
  } catch (_) {
  }
}

async function openTicketDetail(row) {
  detailDialog.visible = true
  detailDialog.ticket = null
  detailDialog.logs = []
  try {
    await loadTicketDetailByID(row.id)
  } catch (_) {
    detailDialog.visible = false
  }
}

async function openAssign(row) {
  try {
    const { value } = await ElMessageBox.prompt('请输入指派的管理员ID', `指派工单 #${row.id}`, {
      inputValue: String(row.assignee_id || ''),
      confirmButtonText: '确认',
      cancelButtonText: '取消'
    })
    const assigneeId = Number(value || 0)
    if (!assigneeId) return
    await adminApi.ticketAssign(row.id, { assignee_id: assigneeId })
    ElMessage.success('指派成功')
    await loadTickets()
  } catch (e) {
    if (e === 'cancel') return
    ElMessage.error(e.message || '指派失败')
  }
}

async function detailAssign() {
  if (!detailDialog.ticket?.id) return
  await openAssign(detailDialog.ticket)
  await refreshDetailDialog()
}

async function copyLastMessage(row) {
  const text = row.last_user_message || row.content || ''
  if (!text) {
    ElMessage.warning('暂无可复制内容')
    return
  }
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      ElMessage.success('已复制')
      return
    }
  } catch (_) {
  }
  try {
    const input = document.createElement('textarea')
    input.value = text
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
    ElMessage.success('已复制')
  } catch (_) {
    ElMessage.error('复制失败，请手动复制')
  }
}

async function copyDetailSummary() {
  const ticket = detailDialog.ticket
  if (!ticket) return
  const text = [
    `工单 #${ticket.id}`,
    `状态：${statusText(ticket.status)}`,
    `分类：${categoryText(ticket.category)}`,
    `优先级：${priorityText(ticket.priority)}`,
    `用户：${ticket.user_id || '-'}`,
    `诉求：${ticket.content || '-'}`,
    `结论：${ticket.resolution || '未处理'}`
  ].join('\n')
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(text)
      ElMessage.success('摘要已复制')
      return
    }
  } catch (_) {}
  try {
    const input = document.createElement('textarea')
    input.value = text
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
    ElMessage.success('摘要已复制')
  } catch (_) {
    ElMessage.error('复制失败，请手动复制')
  }
}

async function openResolve(row) {
  try {
    const { value } = await ElMessageBox.prompt('请输入处理结论', `处理工单 #${row.id}`, {
      inputType: 'textarea',
      confirmButtonText: '提交',
      cancelButtonText: '取消'
    })
    if (!value) return
    await adminApi.ticketResolve(row.id, { resolution: value })
    ElMessage.success('工单已处理')
    await loadTickets()
  } catch (e) {
    if (e === 'cancel') return
    ElMessage.error(e.message || '处理失败')
  }
}

async function detailResolve() {
  if (!detailDialog.ticket?.id) return
  await openResolve(detailDialog.ticket)
  await refreshDetailDialog()
}

async function setHighPriority(row) {
  const next = row.priority === 'high' || row.priority === 'urgent' ? 'urgent' : 'high'
  try {
    await adminApi.ticketSetPriority(row.id, { priority: next, comment: '后台快捷升优先级' })
    ElMessage.success(`优先级已更新为 ${priorityText(next)}`)
    await loadTickets()
  } catch (e) {
    ElMessage.error(e.message || '更新优先级失败')
  }
}

async function detailSetHighPriority() {
  if (!detailDialog.ticket?.id) return
  await setHighPriority(detailDialog.ticket)
  await refreshDetailDialog()
}

async function runAutoEscalate() {
  autoEscalateLoading.value = true
  try {
    const data = await adminApi.ticketAutoEscalate({
      overdue_hours: ticketQuery.overdue_hours || 24,
      to_priority: 'high',
      statuses: ['open', 'processing'],
      only_unassigned: !!ticketQuery.auto_only_unassigned,
      only_urged: !!ticketQuery.auto_only_urged,
      min_urge_count: Number(ticketQuery.auto_min_urge_count || 0)
    })
    ElMessage.success(
      `自动升级完成：检查 ${data.checked || 0}，更新 ${data.updated || 0}，跳过催办不足 ${data.skipped_min_urge || 0}`
    )
    await loadTickets()
    await loadTicketAlerts(true)
    await loadAlertHistory()
  } catch (e) {
    ElMessage.error(e.message || '自动升级失败')
  } finally {
    autoEscalateLoading.value = false
  }
}

async function runOpsNow() {
  opsRunLoading.value = true
  try {
    const data = await adminApi.ticketOpsRun({
      run_alerts: true,
      save_alerts: !!opsConfig.save_alert_snapshots,
      days: opsConfig.alerts_days || 1,
      run_escalate: !!opsConfig.run_auto_escalate,
      overdue_hours: opsConfig.escalate_overdue_hours || 24,
      to_priority: opsConfig.escalate_to_priority || 'high',
      statuses: ['open', 'processing'],
      only_unassigned: !!opsConfig.only_unassigned,
      only_urged: !!opsConfig.only_urged,
      min_urge_count: Number(opsConfig.min_urge_count || 0)
    })
    const updated = Number(data?.escalate?.updated || 0)
    ElMessage.success(`巡检完成，自动升级 ${updated} 条工单`)
    await loadTicketKpi()
    await loadTicketAlerts(false)
    await loadAlertHistory()
    await loadOpsRuns()
    await loadTickets()
  } catch (e) {
    ElMessage.error(e.message || '巡检执行失败')
  } finally {
    opsRunLoading.value = false
  }
}

onMounted(async () => {
  await loadOpsConfig()
  await loadOpsRuns()
  await loadReports()
  await loadTicketKpi()
  await loadTicketAlerts(false)
  await loadAlertHistory()
  await loadTickets()
  failedCountTimer = setInterval(() => {
    loadFailedOpsCount()
  }, 30000)
})

onUnmounted(() => {
  if (failedCountTimer) {
    clearInterval(failedCountTimer)
    failedCountTimer = null
  }
})
</script>

<style scoped>
.json-pre {
	margin: 0;
	padding: 10px;
	border-radius: 8px;
	background: #0f172a;
	color: #e5e7eb;
	font-size: 12px;
	line-height: 1.5;
	max-height: 280px;
	overflow: auto;
}

.escalated-count {
	font-weight: 600;
	color: #6b7280;
}

.escalated-count.hot {
	color: #d97706;
}

:deep(.ops-run-highlight) {
	background: rgba(220, 38, 38, 0.08);
}

.detail-summary-card {
	margin-bottom: 12px;
}

.detail-summary-top {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 12px;
	flex-wrap: wrap;
}

.detail-summary-left {
	min-width: 280px;
}

.ticket-main-id {
	font-size: 20px;
	font-weight: 700;
	color: #111827;
}

.ticket-sub-meta {
	margin-top: 6px;
	font-size: 12px;
	color: #6b7280;
}

.detail-summary-bottom {
	margin-top: 10px;
	padding-top: 10px;
	border-top: 1px dashed #e5e7eb;
}

.detail-progress-card {
	margin-bottom: 12px;
}

.detail-sla-row {
	margin-top: 14px;
}

.detail-info-card {
	margin-bottom: 12px;
}

.detail-card-header {
	font-weight: 700;
}

.detail-block-content {
	font-size: 13px;
	line-height: 1.7;
	color: #111827;
	white-space: pre-wrap;
	word-break: break-word;
}

.detail-block-content.muted {
	color: #9ca3af;
}

.detail-timeline-card {
	margin-top: 6px;
}

.timeline-title {
	font-weight: 600;
	color: #111827;
}

.timeline-detail {
	margin-top: 4px;
	color: #6b7280;
	line-height: 1.6;
	word-break: break-word;
}

.report-detail-summary-card {
	margin-bottom: 12px;
}

.report-detail-top {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 12px;
	flex-wrap: wrap;
}

.report-main-id {
	font-size: 18px;
	font-weight: 700;
	color: #111827;
	word-break: break-all;
}

.report-sub-meta {
	margin-top: 6px;
	font-size: 12px;
	color: #6b7280;
}

.report-detail-actions {
	margin-top: 10px;
	padding-top: 10px;
	border-top: 1px dashed #e5e7eb;
}

.report-detail-card {
	margin-bottom: 12px;
}

.report-detail-content {
	font-size: 13px;
	line-height: 1.7;
	color: #111827;
	white-space: pre-wrap;
	word-break: break-word;
}
</style>
